import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class QuoteProductVisibilityPolicyListDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary, Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary, QuoteProductVisibilityPolicySummary> {
	protected map(entity: Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary): QuoteProductVisibilityPolicySummary {
		return new QuoteProductVisibilityPolicySummaryModel(entity);
	}

	static make(ctx?: any): QuoteProductVisibilityPolicyListDataService {
		return new QuoteProductVisibilityPolicyListDataService(ctx, ctx => ctx.QuoteProductVisibilityPolicySummaries);
	}
}

export class QuoteProductVisibilityPolicySummaryModel extends EntityModel<Model.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary, QuoteProductVisibilityPolicySummary> implements QuoteProductVisibilityPolicySummary {
	@property<QuoteProductVisibilityPolicySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<QuoteProductVisibilityPolicySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<QuoteProductVisibilityPolicySummaryModel>(o => o.entity.isActive, (o, value) => o.entity.isActive = value)
	public isActive: boolean;
	@property<QuoteProductVisibilityPolicySummaryModel>(o => o.entity.hasRules, (o, value) => o.entity.hasRules = value)
	public hasRules: boolean;
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-product-visibility-policies/list/quote-product-visibility-policy-list.data.ts